import { Box, Typography, Button, Stack } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import React, { useState, useEffect } from "react";
import strings from "../../Localization/localizationStrings"
import { useLoading, useAuth, useSnackbar, useNavigation } from '../../Context/Contexts';
import { SalesDocumentViewModel } from "../../Types/ExportTypes";
import { useTranslation } from "react-i18next";

const SuccessSetup: React.FC = () => {
    const { isLoading } = useLoading();
    const { authService } = useAuth();
    const { showSnackbar } = useSnackbar();
    const { navigate } = useNavigation();
    const [loading, setLoading] = useState(false);
    const { t } = useTranslation();

    const handleCreateOrder = async () => {
        setLoading(true);
        try {
            const response = await authService.post<SalesDocumentViewModel>("/orderApi/CreateOrder", {});
            navigate({ path: "/sales/order/edit", params: { orderNo: response.no } });
        } catch (error: any) {
            showSnackbar(`${t("common.failedToCreateOrder")} : ${error.response?.data ?? error.message}`, "error");
        } finally {
            setLoading(false);
        }
    };

    const handleCreateItem = () => {
        navigate({ path: "/purchase/item/edit", params: { itemNo: "" } });
    };

    const handleRunReport = () => {
        navigate({ path: "/report/sales/item" })
    };

    return (
        <>
            {!isLoading && (
                <>
                    <Box textAlign="center" mt={8}>
                        <CheckCircleOutlineIcon sx={{ fontSize: 80, color: "green" }} />
                        <Typography variant="h4" mt={2}>
                            {t("common.setupSuccessTitle")}
                        </Typography>
                        <Typography variant="subtitle1" mt={1} mb={4}>
                            {t("common.setupSuccessText")}
                        </Typography>
                        <Stack spacing={2} direction="column" alignItems="center">
                            <Button variant="contained" color="primary" onClick={handleCreateItem}>
                                {t("common.createItem")}
                            </Button>

                            <Button variant="outlined" color="primary" onClick={handleCreateOrder} disabled={loading}>
                                {t("common.createFirstOrder")}
                            </Button>
                     
                            <Button variant="contained" color="success" onClick={handleRunReport}>
                                {t("common.runSalesReport")}
                            </Button>
                            <Button variant="contained" color="info" onClick={() => navigate({ path: "/home" })}>{t("common.goToStart")}</Button>
                        </Stack>
                    </Box>
                </>
            )}
        </>
    );
}
export default SuccessSetup;